export function teamPrintLabel(team) {
  if (team.team_name) {
    return team.team_name
  }
  return `#${team.number} - ${team.access_code}`
}

export function formatTeamAnswerLine(team, questionId, answersField = `answers`) {
  if (team.permanent) {
    return null
  }

  const responses = team[answersField]
  if (!responses) {
    return null
  }

  const answerData = responses[String(questionId)] ?? responses[questionId]
  if (!answerData || !answerData.prevAnswers || answerData.prevAnswers.length === 0) {
    return null
  }

  const numGuesses = answerData.numGuesses ?? answerData.prevAnswers.length
  const points = answerData.points ?? 0
  const isCorrect = Boolean(answerData.isCorrect)
  const guessText = answerData.prevAnswers
    .map((guess, index) => {
      const isLast = index === answerData.prevAnswers.length - 1
      const icon = isLast && isCorrect ? ` ✅` : ` ❌`
      return `${guess}${icon}`
    })
    .join(` `)

  return `${teamPrintLabel(team)}: (${numGuesses} tries, ${points} points earned) ${guessText}`
}

export function getTeamAnswerLines(teams, questionId, answersField = `answers`) {
  if (!teams || !teams.length) {
    return []
  }

  return teams.map(team => formatTeamAnswerLine(team, questionId, answersField)).filter(Boolean)
}
